import React from 'react';
import { cx } from './cx';

export interface StepperProps {
  steps: React.ReactNode[];
  /** Zero-based index of the current step. */
  current: number;
  /** Accessible name of the step list, e.g. "Ticket progress" (translated). */
  'aria-label'?: string;
  className?: string;
}

/** Linear progress through a flow; done and current steps carry the beam. */
export default function Stepper({ steps, current, 'aria-label': ariaLabel, className }: StepperProps) {
  return (
    <ol aria-label={ariaLabel} className={cx('m-0 grid list-none gap-2 p-0', className)} style={{ gridTemplateColumns: `repeat(${steps.length}, minmax(0, 1fr))` }}>
      {steps.map((label, i) => {
        const state = i < current ? 'done' : i === current ? 'current' : 'upcoming';
        return (
          <li key={i} aria-current={state === 'current' ? 'step' : undefined} className="flex min-w-0 flex-col gap-1.5">
            <span aria-hidden className={cx('h-1 rounded-full', state === 'upcoming' ? 'bg-action-neutral-hover' : 'bg-beam')} />
            <span className={cx('break-words text-balance font-ui text-small', state === 'upcoming' ? 'text-tertiary' : 'text-primary')}>{label}</span>
          </li>
        );
      })}
    </ol>
  );
}
